// TODO: Import React module
import React, { useEffect, useRef, useState } from 'react';
import HTMLFlipBook from 'react-pageflip';

// TODO: Import MUI module
import {
    Alert, Box, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography,
    useMediaQuery, useTheme,
} from '@mui/material';

// TODO: Import MUI icon
import { Close, Fullscreen, HelpOutline } from '@mui/icons-material';

// TODO: Import context
import { Context, } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component

const EBook = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component EBook Rendered');

    // TODO: Define useContext
    const { language } = React.useContext(Context);

    // TODO: Define variable
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));
    const isSm = useMediaQuery(theme.breakpoints.only('sm'));
    const isMd = useMediaQuery(theme.breakpoints.only('md'));
    const isLg = useMediaQuery(theme.breakpoints.only('lg'));
    const isXl = useMediaQuery(theme.breakpoints.only('xl'));

    const book = {
        Pages: ['01.png', '02.png', '03.png', '04.png', '05.png', '06.png', '07.png', '08.png', '09.png', '10.png',],
        Path: 'https://www.pohtyh.edu.hk/Files/CampusDevelopment/BlessedBotanicals/EBook/',
    };

    const [open, setOpen] = useState(false);

    // TODO: Define event
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // TODO: Return component
    const FlipBook = () => {
        const containerRef = useRef(null);
        const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

        useEffect(() => {
            const updateSize = () => {
                if (containerRef.current) {
                    const width = containerRef.current.offsetWidth;
                    setDimensions({
                        width,
                        height: width * (9 / 16) // 16:9 ���
                    });
                }
            };

            updateSize();
            window.addEventListener('resize', updateSize);

            return () => window.removeEventListener('resize', updateSize);
        }, []);

        return (
            <Box ref={containerRef} sx={{
                overflow: 'hidden', width: '100%',
                aspectRatio: '16/9', // �O���e�����
                position: 'relative'
            }}
            >
                {dimensions.width > 0 && <HTMLFlipBook
                    width={dimensions.width}
                    height={dimensions.height}
                    style={{
                        width: '100%',
                        height: '100%'
                    }}
                >
                    {book.Pages.map((item, i) => (
                        <div key={i}>
                            <img
                                alt={`Page ${i + 1}`}
                                loading="lazy"
                                src={book.Path + item}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                    ))}
                </HTMLFlipBook>}
                <Alert icon={<HelpOutline fontSize="inherit" />} severity="info" sx={{ borderRadius: 0 }}>
                    {Text.CampusDevelopment.BlessedBotanicals.EBook.SwipeLeft[language]}
                </Alert>
            </Box>
        )
    };

    return (
        <Box id="EBook" sx={{ py: 4, }}>
            <Typography
                gutterBottom
                sx={{ color: 'success.dark', fontWeight: 'bold', textAlign: 'center', }}
                variant="h4"
            >
                {Text.CampusDevelopment.BlessedBotanicals.EBook.Title[language]}
            </Typography>
            <Typography gutterBottom variant="body1">
                {Text.CampusDevelopment.BlessedBotanicals.EBook.Description[language]}
            </Typography>
            <Stack className="SectionEBook" spacing={2}>
                <Box
                    onClick={handleOpen}
                    sx={{
                        width: 1,
                        mx: 'auto',
                        aspectRatio: '16/9',
                        position: 'relative',
                        cursor: 'pointer',
                    }}
                >
                    <img
                        src={book.Path + book.Pages[0]}
                        alt="EBook Preview"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: theme.shape.borderRadius
                        }}
                    />
                    {/* �a�B�|�[�h */}
                    <Box
                        className="preview-overlay"
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0,0,0,0.5)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                            opacity: 1,
                        }}
                    >
                        <Fullscreen fontSize="large" />
                        <Typography variant="h6" sx={{ mt: 1 }}>
                            {Text.CampusDevelopment.BlessedBotanicals.EBook.ViewFullscreen[language]}
                        </Typography>
                    </Box>
                </Box>
                <Typography sx={{ color: 'info.main', textAlign: 'center', }} variant="body1">
                    {Text.CampusDevelopment.BlessedBotanicals.EBook.KeepUpdate[language]}
                </Typography>
            </Stack>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="lg"
                fullWidth
                fullScreen={isMobile}
            >
                <DialogTitle sx={{
                    m: 0,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: theme.palette.primary.main,
                    color: 'white'
                }}>
                    <Typography variant="h6">
                        {Text.CampusDevelopment.BlessedBotanicals.EBook.Title[language]}
                    </Typography>
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    p: 0,
                    backgroundColor: 'grey',
                    overflow: 'hidden',
                }}>
                    <FlipBook />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default EBook;